import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import Box from '@mui/material/Box';
import {catalogueTransition} from '../../../services/CatalogueServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';
import {taskPoolServices} from '../../../services/TaskPoolServices';
import MenuItem from '@mui/material/MenuItem';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

export default function RejectArtefact(props) {
  const dispatch = useContext(DispatchContext);
  const {open, handleAction, taskPool, roleId, catalogueId} = props;

  const poolId = taskPool?.map(value => value?.role_id);

  const isRoleIdInPool = poolId.includes(roleId);

  let taskPoolId = null;

  if (isRoleIdInPool) {
    const index = poolId.indexOf(roleId);

    if (index !== -1) {
      taskPoolId = taskPool[index]?.id;
    }
  }

  const onSubmit = (values) => {
    const request = catalogueId
      ? catalogueTransition('put', catalogueId, {...values})
      : taskPoolServices('put', taskPoolId, {...values});

    request.then(() => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Action completed successfully'}
      });
      handleAction();
      window.location.reload();
    });
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle color={'#616B88'} sx={{fontSize: 30}} className={'text-bold'}
                   fontWeight={700}>Rejection reason</DialogTitle>
      <Box className={'common-divider'}/>
      <Formik initialValues={{action: 'reject_with_changes', remarks: ''}}
              onSubmit={onSubmit}
        // validationSchema={userValidation}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <DialogContent sx={{width: 300}}>
              <Field
                component={TextField}
                name="action"
                label="Action"
                select
                fullWidth
                variant={'outlined'}
                size={'small'}
                sx={{mb: 2}}
              >
                <MenuItem value={'reject_with_changes'}>Reject with changes</MenuItem>
                <MenuItem value={'reject'}>Reject</MenuItem>
              </Field>
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Reason for rejection'}
                     name="remarks" multiline rows={5}
                     InputLabelProps={{
                       style: {fontSize: 14, color: '#929191'}
                     }}/>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAction} variant={'outlined'}
                      color={'error'} className={'text-capitalize'}>
                Cancel
              </Button>
              <Button variant={'contained'} type={'submit'} className={'text-capitalize'}>Confirm</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}